<template>
	<div>
		<el-card>
			<el-table ref="multipleTable" :data="userList" tooltip-effect="dark">
				<el-table-column prop="uid" label="ID" width="50"> </el-table-column>
				<el-table-column prop="avatar" label="头像" width="80">
					<template slot-scope="scope">
						<el-avatar :size="50" :src="scope.row.avatar"></el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="用户名" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="sex" label="性别"> </el-table-column>
				<el-table-column prop="phone" label="手机号" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="create_time" label="注册时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="update_time" label="最后登录时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column width="200px;">
					<template slot-scope="scope">
						<el-button type="primary" @click="onFlollow(scope.row.uid,scope.$index)">关注</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="total,prev,pager,next,jumper"
			 :total="userLength">
			</el-pagination>
		</el-card>
		<!-- 选择马甲弹窗 -->
		<el-dialog title="选择马甲" :visible.sync="userDialogVisible" width="70%">
			<el-table ref="multipleTable" :data="vestUserList" tooltip-effect="dark" @selection-change="selsChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="uid" label="ID" width="50"> </el-table-column>
				<el-table-column prop="avatar" label="头像" width="80">
					<template slot-scope="scope">
						<el-avatar :size="50" :src="scope.row.avatar"></el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="用户名" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="gender" label="性别"> </el-table-column>
				<el-table-column prop="city" label="城市" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="create_time" :formatter="$f.timeFormat" label="注册时间" show-overflow-tooltip>
				</el-table-column>
			</el-table>
			<el-pagination @current-change="handleUserCurrentChange" :current-page="usercurrentPage" :page-size="pagesize"
				layout="total,prev,pager,next,jumper" :total="userLength">
			</el-pagination>
			<div slot="footer">
				<el-button @click="userDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="onSubmit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				currentPage: 1, //初始页
				usercurrentPage:1,
				pagesize: 10,
				userList: [],
				userLength: 0,
				userDialogVisible:false,
				vestUserList:[],
				form:{
					uids:"",
					follow_uid:""
				}
			};
		},
		created() {
			this.handleUserList();
			this.getvestUserList();
		},
		methods: {
			onSubmit(){
				let loading = this.$loading({
					text: '请求中',
				})
				
				this.$H.post("user/vestUserFollow",this.form).then( res =>{
					if(res.code == 200){
						loading.close();
						this.userDialogVisible = false;
						this.$message.success("操作成功")
					}
				})
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.handleUserList();
			},
			handleUserCurrentChange(usercurrentPage) {
				this.usercurrentPage = usercurrentPage;
				this.getvestUserList();
			},
			handleUserList() {
				this.$H
					.get("user/list", {
						page: this.currentPage,
					})
					.then((res) => {
						console.log(res);
						this.userList = res.result.data;
						this.userLength = res.result.total;
						this.pagesize = res.result.per_page;
					});
			},
			getvestUserList() {
				this.$H
					.get("user/list", {
						page: this.usercurrentPage,
						type: 2
					})
					.then((res) => {
						this.vestUserList = res.result.data;
						this.userLength = res.result.total;
						this.pagesize = res.result.per_page;
					});
			},
			onFlollow(id,index){
				this.form.follow_uid = id;
				this.userDialogVisible = true;
			},
			selsChange(e) {
			
				let uids = [];
				e.forEach(item => {
					uids.push(item.uid)
				})
			
				this.form.uids = uids
			}
		}
	};
</script>

<style>

</style>
